import moment from "moment";
import React, { useContext, useEffect, useState, useRef, useMemo } from "react";
import { Form, OverlayTrigger, Table, Tooltip, Modal, Button, Tab, Tabs } from "react-bootstrap";
import { withTranslation, useTranslation } from "react-i18next";
import { AiOutlineFunction } from "react-icons/ai";
import { BiPencil } from "react-icons/bi";
import { BsXSquare, BsImageFill, BsFileWordFill, BsFilePdfFill, BsThreeDotsVertical, BsFileEarmarkFill, BsX, BsDownload, BsFileEarmarkText, BsEye } from "react-icons/bs";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";
import { FcFinePrint } from "react-icons/fc";
import { toast } from "react-toastify";
import { LoaderContext, RegulationContext, UserContext } from "../../../../App";
import ConfirmationModal from "../../../../components/ConfirmationModal/ConfirmationModal";
import { BACKSPACE_EVT_KEY, DELETE_EVT_KEY, DataViewCategoryType, LS_DV_FILTER_KEY, CompareCategoryType, LS_AUTHORITY_KEY, LS_COMPANY_INFO_KEY, EQUATION_EXECUTION_POLLING_INTERVAL } from "../../../../core/constants/common";
import KPIService from "../../../../core/service/KPIService";
import StandardService from "../../../../core/service/StandardService";
import SubStdService from "../../../../core/service/SubStdService";
import EquationService from "../../../../core/service/EquationService";
import Utils from "../../../../core/utilities/Utils";
import '../DataView.scss';
import QualitativeDataView from "./QualitativeDataView";
import QualitativeDataCardView from "./QualitativeDataCardView";
import { useNavigate } from "react-router-dom";
import DataViewHeaderNew from "./DataViewHeaderNew";
import DataViewFilterNew from "./DataViewFilterNew";
import QuestionService from "../../../../core/service/QuestionService";
import ocr_icon from "../../../../images/ocr_icon.png";
import EquationComponentsPopover from "../../../../components/EquationComponentsPopover/EquationComponentsPopover";

export const getFYAdjustedFilter = (sourceFilter, companyInfo = {}, fallbackYear = new Date().getFullYear()) => {
	const dataFreqType = companyInfo?.frequencyType ?? companyInfo?.dataFrequencyType;
	const normalizedPeriodType = String(sourceFilter?.periodType || '').toUpperCase();
	const isYearlyPeriod = normalizedPeriodType === 'ANNUAL' || normalizedPeriodType === 'YEARLY';

	if (dataFreqType !== 'FY' || !isYearlyPeriod) {
		return sourceFilter;
	}

	const reportingYear = Number(sourceFilter?.reportingPeriod?.split('-')?.[0]) || fallbackYear;
	const fyStartMonth = Utils.getMonthNumber(companyInfo?.financialYearStart || 'APRIL');
	const fyEndMonth = Utils.getMonthNumber(companyInfo?.financialYearEnd || 'MARCH');
	const startYear = reportingYear - 1;
	const endYear = reportingYear;
	const lastDay = String(new Date(endYear, Number(fyEndMonth), 0).getDate()).padStart(2, '0');

	return {
		...sourceFilter,
		periodFrom: `${startYear}-${fyStartMonth}-01`,
		periodTo: `${endYear}-${fyEndMonth}-${lastDay}`
	};
};

const DataViewNew = ({ t, yearFilter, onDataUpdate, type = 'ESG_REPORTING' }) => {

	const dvFilter = JSON.parse(localStorage.getItem(LS_DV_FILTER_KEY));
	const lsData = JSON.parse(localStorage.getItem(LS_AUTHORITY_KEY));
	const companyId = lsData.profile.company.id;
	const { glbRegulation } = useContext(RegulationContext);
	const { userDetails } = useContext(UserContext);
	const glbRegulationId = glbRegulation?.id ?? "";
	const month = Utils.getMonthFromFrequency(glbRegulation.frequency);
	const year = new Date().getFullYear();
	const { setLoaderDisplay } = useContext(LoaderContext);

	const [filter, setFilter] = useState({
		reportingPeriod: yearFilter ? `${yearFilter}-01-01` : dvFilter?.reportingPeriod ?? `${year}-${month}-01`,
		categoryType: dvFilter?.categoryType ?? DataViewCategoryType.ENVIRONMENTAL,
		topicIds: dvFilter?.topicIds ?? [],
		metricIds: dvFilter?.metricIds ?? [],
		businessUnitIds: dvFilter?.businessUnitIds ?? [],
		parentEntities: dvFilter?.parentEntities ?? [],
		childEntities: dvFilter?.childEntities ?? [],
		periodFrom: dvFilter?.periodFrom ?? `${year}-01-01`,
		periodTo: dvFilter?.periodTo != null ? dvFilter?.periodTo : dvFilter?.periodType == 'MONTHLY' ? null : `${year}-12-31`,
		groupIds: dvFilter?.groupIds ?? [],
		periodType: dvFilter?.periodType ?? 'ANNUAL',
		period: dvFilter?.period ?? null,
		showQuantitative: dvFilter?.showQuantitative ?? true,
		showQualitative: dvFilter?.showQualitative ?? false
	});
	const [dataViewData, setDataViewData] = useState([]);
	const [dataPoints, setDataPoints] = useState({});
	const [topicVisibility, setTopicVisibility] = useState({});
	const [dpVisibility, setDPVisibility] = useState({});
	const [metricDPToSave, setMetricDPToSave] = useState([]);
	const [branchColEdited, setBranchColEdited] = useState({});
	const [uomList, setUOMList] = useState([]);
	const [branchDPToSave, setBranchDPToSave] = useState([]);
	const [showBranchDPSaveButton, setShowBranchDPSaveButton] = useState(false);
	const [validation, setValidation] = useState({});
	const [showFilter, setShowFilter] = useState(false);
	const [view, setView] = useState('CONSOLIDATED_VIEW');
	const [validCheck, setValidCheck] = useState('')
	const [editedBranch, setEditedBranch] = useState(null)
	const [viewType, setViewType] = useState(type);
	const [showModal, setShowModal] = useState(false);
	const [showReportedValueModal, setShowReportedValueModal] = useState(false);
	const [attachedFiles, setAttachedFiles] = useState([]);
	const [dpComments, setDPComments] = useState('');
	const [selectedDp, setSelectedDp] = useState({});
	const [fileUploader, setFileUploader] = useState('');
	const [selectedFile, setSelectedFile] = useState({});
	const [showConfirmation, setShowConfirmation] = useState(false);
	const [messageConfirmation, setMessageConfirmation] = useState('');
	const [isCommentEdit, setIsCommentEdit] = useState(false);
	const [tempComments, setTempComments] = useState('');
	const [tempAttachments, setTempAttachments] = useState([]);
	const [showPreviewModal, setShowPreviewModal] = useState(false);
	const [previewData, setPreviewData] = useState({});
	const [activeTab, setActiveTab] = useState('pdf');
	const fileInputRef = useRef();
	const [key, setKey] = useState('quan');
	const [showQual, setShowQual] = useState(false);
	const [showQuan, setShowQuan] = useState(true);
	const [selectedBranchData, setSelectedBranchData] = useState({});
	const navigate = useNavigate();
	const [colHideShow, setColHideShow] = useState({
		codes: true,
		uom: true,
		userInput: true,
		inUOM: false,
		showTotalReportedValue: false
	});
	const [equationExecutionInProgress, setEquationExecutionInProgress] = useState(false);
	const [dataStale, setDataStale] = useState(false);
	const [selectedEditDp, setSelectedEditDp] = useState([]);
	const [sortOrder, setSortOrder] = useState(null);
	const { k, i18n } = useTranslation();
	const [parsedMetadata, setParsedMetadata] = useState(null);
	const [showOCRModal, setShowOCRModal] = useState(false);
	const [selectedMetric, setSelectedMetric] = useState(null);
	const [businessUnits, setBusinessUnits] = useState([]);
	const topicVisibilityInitialized = useRef(false);
	const companyInfo = JSON.parse(localStorage.getItem(LS_COMPANY_INFO_KEY) || '{}');

	useEffect(() => {
		getUOMs();
	}, []);

	// Poller to check equation execution status every 5 seconds - runs continuously
	// (not just while already known to be in progress) so it also picks up execution
	// starting independently, e.g. triggered elsewhere.
	// Deliberately no setLoaderDisplay(true) here - the user keeps working (viewing/editing)
	// while execution is in progress; only the status banner in the header reflects it.
	// Re-created whenever the state checkEquationExecutionStatus reads changes, so the poller
	// never acts on a stale closure of view/edit-in-progress/filter.
	useEffect(() => {
		checkEquationExecutionStatus();
		const pollerInterval = setInterval(() => {
			checkEquationExecutionStatus();
		}, EQUATION_EXECUTION_POLLING_INTERVAL);

		return () => {
			clearInterval(pollerInterval);
		};
	}, [equationExecutionInProgress, view, showBranchDPSaveButton, editedBranch, branchColEdited, filter]);

	useEffect(() => {
		if (view == 'CONSOLIDATED_VIEW') {
			setBranchColEdited({});
		}
	}, [view]);

	useEffect(() => {
		if (!glbRegulationId) return;
		if (showQuan) {
			getDataViewData(filter).catch(() => {});
		}
	}, [glbRegulationId]);

	// Initialize topic visibility only on the very first load: show first topic with metrics, hide others
	// On refresh/reload, preserve existing visibility state
	useEffect(() => {
		if (!topicVisibilityInitialized.current && dataViewData.length > 0) {
			const topicVisibilityData = initializeTopicVisibility(dataViewData);
			setTopicVisibility(topicVisibilityData);
			topicVisibilityInitialized.current = true;
		}
	}, [dataViewData]);

	// useEffect(() => {
	// 	return () => {
	// 		if (showBranchDPSaveButton) {
	// 			setEditedBranch('edited');
	// 		}
	// 	};
	// }, [showBranchDPSaveButton]);

	const getDataViewData = (f, v = true) => {
		const filterForApi = f.periodFrom && f.showQuantitative
			? { ...f, reportingPeriod: f.periodFrom }
			: f;
		const apiFilter = getFYAdjustedFilter(filterForApi, companyInfo, year);
		setLoaderDisplay(true);
		return StandardService.getMetricsByFilter(glbRegulationId, apiFilter.reportingPeriod, apiFilter, v)
			.then(res => {
				setLoaderDisplay(false);
				if (res.status !== 200) {
					return Promise.reject(new Error('Failed to fetch data view data'));
				}
				const resData = res.data;
				const transformedData = resData.map((obj) => transformObject(obj));
				transformedData.sort((a, b) => (a.sortOrder ?? Number.MAX_SAFE_INTEGER) - (b.sortOrder ?? Number.MAX_SAFE_INTEGER));
				setDataViewData(transformedData);
				setDataStale(false);

				// If some metric was already in expanded state,
				// then keep its state unchanged unless the topic has changed in the new filter
				let previousTopicExists = false;
				for (let i = 0; i < f.topicIds?.length; i++) {
					const topicId = f.topicIds[i];
					if (filter.topicIds?.indexOf(topicId) < 0) continue;

					previousTopicExists = true;
					break;
				}
				let dpVisibilityData = JSON.parse(JSON.stringify(dpVisibility));
				if (!previousTopicExists && f.topicIds?.length > 0) {
					dpVisibilityData = {};
				}
				setDPVisibility(dpVisibilityData);
				// Refresh datapoints data for the displayed datapoints
				const metricIds = Object.keys(dpVisibilityData);
				if (metricIds?.length == 0) {
					setDataPoints({});
				}

				metricIds?.forEach(metricId => {

					if (!dpVisibilityData[metricId] || dpVisibilityData[metricId] === 'hide') return;

					getDataPoints(+metricId, apiFilter, v);
				});
			}).catch(err => {
				setLoaderDisplay(false);
				return Promise.reject(err);
			});
	};

	const transformObject = (obj) => {
		const transformedObj = { ...obj };
		// Add the translated values to the main object based on languageCode
		if (obj.localizedContents && obj.localizedContents.length > 0) {
			obj.localizedContents.forEach((item) => {
				if (item.fieldName === 'name') {
					transformedObj[item.languageCode] = item.translatedValue;
				} else if (item.fieldName === 'description') {
					transformedObj[`${item.languageCode}_description`] = item.translatedValue;
				}
			});
		}
		// Recursively process the children objects
		if (obj.metricData && obj.metricData.length > 0) {
			transformedObj.metricData = obj.metricData.map((child) => transformObject(child));
		}

		return transformedObj;
	};

	// Helper function to initialize topic visibility: show first topic with metrics, hide others
	const initializeTopicVisibility = (topics) => {
		if (!topics || topics.length === 0) return {};
		
		let topicVisibilityData = {};
		let firstTopicWithMetricsFound = false;
		
		topics.forEach((topic) => {
			if (topic.topicId) {
				// Check if this topic has non-empty metricData
				const hasMetrics = topic.metricData && Array.isArray(topic.metricData) && topic.metricData.length > 0;
				
				if (hasMetrics && !firstTopicWithMetricsFound) {
					// First topic with metrics: show
					topicVisibilityData[topic.topicId] = 'show';
					firstTopicWithMetricsFound = true;
				} else {
					// All other topics (including those without metrics): hide
					topicVisibilityData[topic.topicId] = 'hide';
				}
			}
		});
		
		// If no topic has metrics, show the first topic anyway
		if (!firstTopicWithMetricsFound && topics.length > 0 && topics[0].topicId) {
			topicVisibilityData[topics[0].topicId] = 'show';
			// Hide all others
			topics.forEach((topic, index) => {
				if (index > 0 && topic.topicId) {
					topicVisibilityData[topic.topicId] = 'hide';
				}
			});
		}
		
		return topicVisibilityData;
	};


	const saveChangesConfirmationCallBack = (val) => {
		if (!val) {
			// onColCancelEdit(editedBranch)
			setEditedBranch(null);
			setBranchColEdited({});
			setShowBranchDPSaveButton(false);
			setView('CONSOLIDATED_VIEW');
			return
		}
		// saveMetricDataPoint();
		saveBranchDataPoint();
		setEditedBranch(null);
		setBranchColEdited({});
		setShowBranchDPSaveButton(false);
		setView('CONSOLIDATED_VIEW');
	}
	const getDataPoints = (metricId, f, v = true) => {
		const filterToUse = f ? f : filter;
		const apiFilter = getFYAdjustedFilter(filterToUse, companyInfo, year);
		setLoaderDisplay(true);
		SubStdService.getBranchBasedData(
			glbRegulationId,
			metricId,
			apiFilter.reportingPeriod,
			apiFilter.businessUnitIds,
			apiFilter.periodFrom,
			apiFilter.periodTo,
			apiFilter.groupIds,
			v,
			colHideShow.showTotalReportedValue,
		).then((res) => {
			setLoaderDisplay(false);
			if (res.status !== 200) return;


			const transformedData = res.data.dataPoints.map((obj) => transformObject(obj));
			setDataPoints(existingDPs => {
				// existingDPs[metricId] = [];
				existingDPs[metricId] = transformedData;
				return existingDPs;
			});

			const vis = { ...dpVisibility };
			vis[metricId] = 'show';
			setDPVisibility(vis);
		})
			.catch((e) => {
				setLoaderDisplay(false);
			});
	};

	useEffect(() => {
		Object.keys(dpVisibility).forEach(metricId => {
			if (dpVisibility[metricId] !== 'show') return;
			getDataPoints(+metricId);
		});
	}, [colHideShow.showTotalReportedValue]);

	const getUOMs = () => {
		StandardService.getUnitsOfMeasure()
			.then(res => {
				if (res.status !== 200) return;

				setUOMList(res.data.data);
			})
			.catch((error) => { });
	};


	const isUserDataValidator = (branchId) => {
		// Parent entities: edit not allowed — only child entities can be edited
		if (filter.parentEntities && filter.parentEntities.indexOf(branchId) >= 0) {
			return false;
		}

		if (!userDetails || !userDetails.profile || !userDetails.profile.user) {
			return false;
		}

		const currentUserId = userDetails.profile.user.id;
		
		// Check if user is a data validator for ANY business unit
		const isValidatorForAnyUnit = businessUnits.some(bu => 
			bu.dataValidators && bu.dataValidators.some(validator => validator.id === currentUserId)
		);

		// If user is not a data validator for ANY unit, they can edit ALL units
		if (!isValidatorForAnyUnit) {
			return true;
		}

		// If user is a data validator for some units, check if they can edit this specific unit
		const businessUnit = businessUnits.find(bu => bu.id === branchId);
		
		if (!businessUnit || !businessUnit.dataValidators) {
			return false;
		}

		// User can only edit this specific unit if they are a data validator for it
		return businessUnit.dataValidators.some(validator => validator.id === currentUserId);
	};

	const commitAppliedFilter = (f) => {
		setFilter(f);
		localStorage.setItem(LS_DV_FILTER_KEY, JSON.stringify(f));
	};

	const applyFilter = (f) => {
		if (f.showQuantitative) {
			getDataViewData(f)
				.then(() => commitAppliedFilter(f))
				.catch(() => { /* toast already shown by interceptor */ });
			return;
		}
		commitAppliedFilter(f);
	};

	const resetData = () => {
		setDataViewData([]);
		setDataPoints({});
	}

	const showOrHideTopic = (topicId) => {
		const vis = { ...topicVisibility };
		// vis[topicId] = vis[topicId] === 'hide' ? 'show' : 'hide';
		const isCollapsing = vis[topicId] !== 'hide';
		vis[topicId] = isCollapsing ? 'hide' : 'show';
		setTopicVisibility(vis);

		// When collapsing topic, also collapse all inner metrics and clear their data points
		if (isCollapsing) {
			const topic = dataViewData?.find(t => t.topicId === topicId);
			const metricIds = topic?.metricData?.map(m => m.id) ?? [];
			if (metricIds.length > 0) {
				const dpVis = { ...dpVisibility };
				metricIds.forEach(metricId => { dpVis[metricId] = 'hide'; });
				setDPVisibility(dpVis);
				setDataPoints(prev => {
					const next = { ...prev };
					metricIds.forEach(metricId => { next[metricId] = []; });
					return next;
				});
			}
		}
	};

	const showOrHideDataPoints = (metricId) => {
		const vis = { ...dpVisibility };
		vis[metricId] = vis[metricId] === 'show' ? 'hide' : 'show';
		setDPVisibility(vis);
		if (vis[metricId] === 'hide') {
			const existingDPs = JSON.parse(JSON.stringify(dataPoints));
			existingDPs[metricId] = [];
			setDataPoints(existingDPs);
			return;
		}
		getDataPoints(metricId);
	};

	const showDataPoints = (metricId) => {
		if (dpVisibility[metricId] === 'show' && dataPoints[metricId]?.length) {
			return;
		}
		const vis = { ...dpVisibility };
		vis[metricId] = 'show';
		setDPVisibility(vis);
		getDataPoints(metricId);
	};

	const metricDPChanged = (metric, branchId) => (e) => {
		const data = [...metricDPToSave];
		const index = data.findIndex(x => x.metricId === metric.id);
		if (index >= 0) {
			data[index].value = e.target.value;
		} else {
			const dat = {
				id: metric.id,
				value: e.target.value,
				metricId: metric.id,
				branchId: branchId,
			};
			data.push(dat);
		}
		setMetricDPToSave(data);
	};

	const saveMetricDataPoint = () => {
		if (metricDPToSave.length === 0) {
			setView('CONSOLIDATED_VIEW');
			return;
		}
		metricDPToSave?.forEach(dp => {
			dp.value = Utils.parseLocaleNumber(dp.value);
		});
		setLoaderDisplay(true);
		KPIService.saveDataPoint(
			glbRegulationId,
			filter.reportingPeriod,
			{ dataPoints: metricDPToSave }
		).then(res => {
			setLoaderDisplay(false);
			if (res.status !== 200) return;

			toast.success("Data saved successfully", {
				position: toast.POSITION.TOP_RIGHT,
			});
			setView('CONSOLIDATED_VIEW');
			setEditedBranch(null);
			setBranchColEdited({});
			setShowBranchDPSaveButton(false);
			setMetricDPToSave([]);
			getDataViewData(filter).catch(() => {});
			setDataPoints([]);
			onDataUpdate();
		}).catch((error) => {
			setLoaderDisplay(false);
		});
	};

	const onUOMChange = (branchData, dataPointId) => (e) => {
		const data = [...branchDPToSave];
		const index = data.findIndex((x) => ((x.branchId === branchData.branchId) && (x.dataPointId === dataPointId)));
		if (index >= 0) {
			data[index].uom = e.target.value;
		} else {
			const dat = {
				id: branchData.id,
				value: branchData?.valueBeforeConversion ? branchData?.valueBeforeConversion : branchData?.value,
				dataPointId: dataPointId,
				branchId: branchData.branchId,
				uom: e.target.value,
				remark: branchData.remark,
				attachments: branchData.attachments ? branchData.attachments : []
			};
			data.push(dat);
		}
		setBranchDPToSave(data);
	};

	const branchDPChanged = (branchData, dataPointId) => (e) => {
		const data = [...branchDPToSave];
		const index = data.findIndex((x) => ((x.branchId === branchData.branchId) && (x.dataPointId === dataPointId)));
		if (index >= 0) {
			data[index].value = e.target.value;
		} else {
			const dat = {
				id: branchData.id,
				value: e.target.value,
				dataPointId: dataPointId,
				branchId: branchData.branchId,
				uom: branchData.uomBeforeConversion ? branchData?.uomBeforeConversion : branchData?.uom,
				remark: branchData.remark,
				attachments: branchData.attachments ? branchData.attachments : []
			};
			data.push(dat);
		}
		setBranchDPToSave(data);
	};
	const handleKeyPress = (event) => {
		const navigationKeys = ['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End', 'Tab'];
		if (navigationKeys.includes(event.key) || event.ctrlKey || event.metaKey) {
			return;
		}
		// Allow only numbers, decimal point and comma
		if (!(event.key === BACKSPACE_EVT_KEY || event.key === DELETE_EVT_KEY || /^[0-9.,]+$/.test('' + event.key))) {
			event.preventDefault();
		}
	};

	const saveBranchDataPoint = async (e) => {
		if (branchDPToSave.length === 0) {
			setBranchColEdited({});
			return;
		}
		let isValid = true;
		let validationClone = JSON.parse(JSON.stringify(validation));
		for (let i = 0; i < branchDPToSave.length; i++) {
			const dp = branchDPToSave[i];
			if (dp.value && !dp.uom) {
				isValid = false;
				setValidCheck(true)
				break;
			}
			if (dp.value == '' && dp.uom == '') {
				setValidCheck(false)
			}
		}
		// Iterate all for form field validation		
		for (let i = 0; i < branchDPToSave.length; i++) {
			const dp = branchDPToSave[i];
			validationClone[`b-${dp.branchId}`] = true;
			validationClone[`d-${dp.dataPointId}`] = true;
		}
		setValidation(validationClone);
		if (!isValid) {
			toast.error(t("UnitNotSelected.label"), {
				position: toast.POSITION.TOP_RIGHT,
			});
			return;
		}

		// Update branchDPToSave with comments and attachments from dataPoints
		const updatedBranchDPToSave = branchDPToSave.map(dp => {
			let remark = '';
			let attachments = [];

			// Iterate through the metric IDs in dataPoints to find the correct branch
			for (const metricId in dataPoints) {
				const dataPointsArray = dataPoints[metricId];
				// Check if dataPointsArray exists and is an array before calling find
				if (dataPointsArray && Array.isArray(dataPointsArray)) {
					// Find the data point within this metric that matches the current dp.dataPointId
					const dataPointInState = dataPointsArray.find(d => d.id === dp.dataPointId);

					if (dataPointInState) {
						// Find the branch within this data point that matches the current dp.branchId
						const branchInState = dataPointInState.branches?.find(b => b.branchId === dp.branchId);

						if (branchInState) {
							remark = branchInState.remark || '';
							attachments = branchInState.attachments || [];
							// Found the matching branch, no need to check other metrics
							break;
						}
					}
				}
			}

			return {
				...dp,
				remark: remark,
				attachments: attachments,
				value: Utils.parseLocaleNumber(String(dp.value))
			};
		});

		setLoaderDisplay(true);
		SubStdService.saveBranchDataPoint(
			glbRegulationId,
			filter.reportingPeriod,
			{ dataPoints: updatedBranchDPToSave }
		).then(res => {
			setLoaderDisplay(false);
			if (res.status !== 200) return;

			toast.success("Data saved successfully", {
				position: toast.POSITION.TOP_RIGHT,
			});
			setEquationExecutionInProgress(true);
			setView('CONSOLIDATED_VIEW');
			setEditedBranch(null);
			setShowBranchDPSaveButton(false);
			setBranchColEdited({});
			setBranchDPToSave([]);
			getDataViewData(filter).catch(() => {});
			setDataPoints([]);
			setValidation({});
			onDataUpdate();
		}).catch((error) => {
			setLoaderDisplay(false);
		});
	};

	const onColEdit = (branchId) => {
		if (!branchId) {
			return;
		} else {
			const vis = { ...dpVisibility };
			let exists = Object.values(vis).includes("show");

			if (!exists) {
				toast.warning("Please open a metric to edit", {
					position: toast.POSITION.TOP_RIGHT,
				});
			} else {
				const bData = { ...branchColEdited };
				bData[branchId] = true;
				setBranchColEdited(bData);
				setShowBranchDPSaveButton(true);
			}
		}
	};

	const onColCancelEdit = (branchId) => {
		if (!branchId) return;

		const bData = { ...branchColEdited };
		bData[branchId] = false;
		setBranchColEdited(bData);
		setShowBranchDPSaveButton(false);
	};

	const onCalculateEquation = (metricId) => {
		SubStdService.calculateEquation(metricId, filter.reportingPeriod)
			.then((response) => {
				if (response.data?.data) {
					toast.success(response.data.message, {
						position: toast.POSITION.TOP_RIGHT,
					});
					setSelectedMetric(null);
					getDataViewData(filter).catch(() => {});
				} else {
					toast.error(response.data.message, {
						position: toast.POSITION.TOP_RIGHT,
					});
				}
			})
			.catch(er => { });
	};

	const hasQuantitativeMetrics = (metrics) => {
		let hasMetrics = false;
		for (let i = 0; i < metrics?.length; i++) {
			const metric = metrics[i];
			if (metric.category === 'QUANTITATIVE') {
				hasMetrics = true;
				break;
			}
		}
		return hasMetrics;
	};

	const getBranchDisplayName = (branch) => {
		if (!branch) return '';
		if (branch.branchName) return branch.branchName;
		if (branch.name) return branch.name;
		const unit = businessUnits.find(bu => bu.id === branch.branchId);
		return unit?.name || '';
	};

	const getBranchesFromFilteredData = () => {
		for (let index = 0; index < dataViewData?.length; index++) {
			const dvData = dataViewData[index];
			if (!dvData?.metricData?.length) continue;
			const quantitativeMetric = dvData.metricData.find(
				m => m.category !== 'QUALITATIVE' && m.branches?.length > 0
			);
			if (quantitativeMetric?.branches?.length) {
				return quantitativeMetric.branches;
			}
		}
		return [];
	};

	const renderColumnActionIcon = (branchId) => {
		if (view === 'CONSOLIDATED_VIEW') return <></>;

		return (
			<span>
				{
					branchColEdited[branchId]
						?
						<OverlayTrigger
							placement="top"
							overlay={Utils.renderTooltip(t("CancelEdit.label"))}>
							<span>
								<BsXSquare
									className="cursor"
									onClick={() => {
										setEditedBranch(branchId)
									}}></BsXSquare>{" "}
							</span>
						</OverlayTrigger>
						:
						<OverlayTrigger
							placement="top"
							overlay={Utils.renderTooltip(t("Edit.label"))}>
							<span>
								<BiPencil
									className="cursor"
									onClick={() => onColEdit(branchId)} />
							</span>
						</OverlayTrigger>
				}
			</span>
		);
	};

	const renderTableHeader = () => {
		const branches = getBranchesFromFilteredData();
		// In edit mode, hide "User Input" column and always show "In UOM"
		const showUserInput = colHideShow.userInput && view !== 'EDIT_VIEW';
		const showInUOM = view === 'EDIT_VIEW' ? true : colHideShow.inUOM; // Force show in edit mode
		
		// Show sub-headers if both "In UOM" and "User Input" are enabled for child branches
		const hasChildBranchColumns = branches?.some(branch => {
			const isParentBranch = filter.parentEntities?.indexOf(branch.branchId) >= 0;
			const isChildBranch = !isParentBranch && (
				filter.childEntities?.indexOf(branch.branchId) >= 0 || 
				businessUnits.find(bu => bu.id === branch.branchId)?.level === 2
			);
			return isChildBranch && showInUOM && showUserInput;
		});

		// Calculate colSpan for child branches based on enabled columns
		const getChildBranchColSpan = () => {
			let count = 0;
			if (showInUOM) count++;
			if (showUserInput) count++;
			return count || 1; // At least 1 column (one of them must be enabled)
		};

		const childBranchColSpan = getChildBranchColSpan();

		return (
			<thead>
				<tr className="child-branch-header-row_1">
					<th rowSpan={hasChildBranchColumns ? 2 : 1} className="">{t("Topics.label")}</th>
					{colHideShow.codes && <th rowSpan={hasChildBranchColumns ? 2 : 1} className="text-center">Code</th>}
					{colHideShow.uom && <th rowSpan={hasChildBranchColumns ? 2 : 1} className="text-center">UOM</th>}
					<th rowSpan={hasChildBranchColumns ? 2 : 1} className="text-center total-col-header cursor" onClick={handleSort}>
						<span className="mx-1">{t("Total.label")} {" "}
							{sortOrder === "asc" ? "↑" : sortOrder === "desc" ? "↓" : "↕"}</span>
					</th>
					{colHideShow.showTotalReportedValue &&
						<th rowSpan={hasChildBranchColumns ? 2 : 1} className="text-center total-col-header">
							<span className="mx-1">{t("DataViewNew.totalReportedValue.label")}</span>
						</th>
					}
					{
						branches?.map((branch, bIndex) => {
							const isParentBranch = filter.parentEntities?.indexOf(branch.branchId) >= 0;
							const isChildBranch = !isParentBranch && (
								filter.childEntities?.indexOf(branch.branchId) >= 0 || 
								businessUnits.find(bu => bu.id === branch.branchId)?.level === 2
							);
							
							if (isChildBranch && (showInUOM || showUserInput)) {
								// For child branches with "In UOM" or "User Input" enabled, span columns based on enabled options
								return (
									<th key={`branchHeader-${bIndex}`} colSpan={childBranchColSpan} className="branch-cell text-center">
										<span className="mx-1">{getBranchDisplayName(branch)}</span>
									</th>
								);
							} else {
								// For parent branches or child branches without both columns, single column
								return (
									<th key={`branchHeader-${bIndex}`} rowSpan={hasChildBranchColumns ? 2 : 1} className="branch-cell text-center">
										<span className="mx-1">{getBranchDisplayName(branch)}</span>
									</th>
								);
							}
						})
					}
				</tr>
				{hasChildBranchColumns && (
					<tr className="child-branch-header-row">
						{
							branches?.map((branch, bIndex) => {
								const isParentBranch = filter.parentEntities?.indexOf(branch.branchId) >= 0;
								const isChildBranch = !isParentBranch && (
									filter.childEntities?.indexOf(branch.branchId) >= 0 || 
									businessUnits.find(bu => bu.id === branch.branchId)?.level === 2
								);
								
								if (isChildBranch && showInUOM && showUserInput) {
									// Render sub-headers: "In UOM" and "User Input"
									return [
										<th key={`inUOMHeader-${bIndex}`} className="branch-cell text-center">
											<span className="mx-1">{t("DataViewNew.inUOM.label")}</span>
										</th>,
										<th key={`userInputHeader-${bIndex}`} className="branch-cell text-center">
											<span className="mx-1">{t("DataViewNew.userInput.label")}</span>
										</th>
									];
								} else {
									// Empty cell for parent branches (already spanned in first row)
									return null;
								}
							}).filter(Boolean).flat()
						}
					</tr>
				)}
			</thead>
		);
	};

	const renderEmptyDataLabel = () => {
		return (
			<tr>
				<td colSpan="4" className="text-center 2">
					<div className="Nodatafound_box">
						<h6><FcFinePrint className="me-2" />{t("Nodatafound.label")}</h6>
					</div>
				</td>
			</tr>
		)
	};

	const noAttachmentLabel = () => {
		return (
			<div>
				<FcFinePrint className="me-2" /> No attachments available!
			</div>
		)
	};

	const renderCategoryRow = () => {
		const branches = getBranchesFromFilteredData();
		const categoryColSpanValue = (branches?.length ? (branches.length + 2) : 2) + (colHideShow.showTotalReportedValue ? 1 : 0);
		return (
			<tr key={`category`} className="cat-row">
				<td colSpan={categoryColSpanValue} className="name-cell 1">
					<span className="DataCat_sticky">
						<span className="text-primary"><b>{Utils.toTitleCase(t(CompareCategoryType[filter.categoryType]))}</b></span>
					</span>
				</td>
			</tr>
		);
	};

	const renderTopicRow = (topic, index) => {
		const branches = getBranchesFromFilteredData();
		const topicColSpanValue = (branches?.length ? (branches.length + 2) : 2) + (colHideShow.showTotalReportedValue ? 1 : 0);
		return (
			<tr key={`topic-${topic.topicId}-${index}`} className="topic-row">
				<td colSpan={topicColSpanValue} className="name-cell 1">
					<span className="DataTopic_sticky cursor"
						onClick={() => { showOrHideTopic(topic.topicId) }}>
						<span className="left_arrow_head">
							{(topicVisibility[topic.topicId] === 'hide') ? <FaChevronDown /> : <FaChevronUp />}
						</span>
						<span >
							{(i18n.language && topic[i18n.language]) ? topic[i18n.language] : topic.topicName}
							{/* {topic.topicName} */}
						</span>
					</span>
				</td>
			</tr>
		);
	};

	const renderMetricEquationTooltip = (metric) => {
		return (
			<Tooltip className="mytooltip">
				<b>{metric.equation?.expression ?? ''}</b>
			</Tooltip>
		);
	}

	const renderMetricRow = (metric, index, topicId) => {
		if (metric.category === 'QUALITATIVE') return <></>;

		return (
			<tr key={`metric-${metric.id}-${index}`}
				className={topicVisibility[topicId] === 'hide' ? 'metric-row d-none' : 'metric-row'}>
				<td className="name-cell">
					<div>
						<div className={` ${metric.datapointCount > 0 ? 'cursor' : ''}`}
							onClick={() => showOrHideDataPoints(metric.id)}>
							{
								metric.datapointCount > 0 &&
								<span className="cursor left_arrow"  >
									{dpVisibility[metric.id] === 'show' ? <FaChevronUp /> : <FaChevronDown />}
								</span>
							}
							<span>
								{(i18n.language && metric[i18n.language]) ? metric[i18n.language] : metric.name}
								{/* {metric.name} */}

							</span>
						</div>
						<div className="cal_btn">
							{
								metric.code == "ECD073" &&
								<OverlayTrigger
									placement="top"
									overlay={renderGHGEmissionTooltip()}>
									<span className="cursor me-2 text-primary " onClick={() => gotoEditGHGData()}>
										<BsFileEarmarkText />
									</span>
								</OverlayTrigger>
							}
							<OverlayTrigger
								placement="top"
								overlay={renderMetricEquationTooltip(metric)}>
								<span className="cursor text-muted" onClick={() => onCalculateEquation(metric.id)}><AiOutlineFunction /></span>
							</OverlayTrigger>
							<EquationComponentsPopover
								standardId={glbRegulationId}
								equationId={metric?.equation?.expressionWithId || metric?.eqnExpWithId || null}
								headerText={metric?.equation?.expression || metric?.equation?.expressionWithId || metric?.name}
								popoverKey={`dv-metric-${metric.id}-${metric.code || index}`}
								className="cursor text-muted ms-2"
								popoverClassName="equation-components-popover--wide"
								iconSize={14}
							/>
						</div>
					</div>
				</td>
				{colHideShow.codes && <td className="text-center white-space">{metric.code}</td>}
				{colHideShow.uom && <td className="text-center white-space">{metric.unitOfMeasure}</td>}
				<td className="total-cell text-right">
					{
						metric.emissionLinked
							?
							`${Utils.formattedNumber(metric.emissionSolutionInTCO2e)}`
							:
							(metric.value !== null ? `${Utils.formattedNumber(metric.value)}` : '-')
					}
				</td>
				{colHideShow.showTotalReportedValue &&
					<td className="total-cell text-right">
						{metric.totalReportedValue != null ? `${Utils.formattedNumber(metric.totalReportedValue)}` : '-'}
					</td>
				}
				{
					metric.branches?.map((branch, bIndex) => {
						const isParentBranch = filter.parentEntities?.indexOf(branch.branchId) >= 0;
						const isChildBranch = !isParentBranch && (
							filter.childEntities?.indexOf(branch.branchId) >= 0 || 
							businessUnits.find(bu => bu.id === branch.branchId)?.level === 2
						);
						
						// "In UOM" column (main branch cell) - always show in edit mode, otherwise show when enabled
						// For child branches, show as separate column when both are enabled
						const shouldShowInUOM = !isChildBranch || (isChildBranch && (view === 'EDIT_VIEW' ? true : colHideShow.inUOM));
						
						return [
							shouldShowInUOM && (
								<td
									key={`metric-branch-cell-${bIndex}`}
									className={`branch-cell ${filter.parentEntities?.indexOf(branch.branchId) >= 0 ? 'parent-branch-cell' : 'child-branch-cell'}`}>
									<div className="inner_tb">
										{
											metric.emissionLinked
												?
												(branch.emissionSolutionInTCO2e != null ? `${Utils.formattedNumber(branch.emissionSolutionInTCO2e)}` : '-')
												:
												(branch.solution != null ? `${Utils.formattedNumber(branch.solution)}` : '-')
										}
										{(view == 'EDIT_VIEW' && metric.datapointCount > 0 && isUserDataValidator(branch.branchId)) &&
											<span className="hideEdit" onClick={() => editItem(metric.id, branch.branchId)}>
												<BiPencil />
											</span>
										}
									</div>
								</td>
							),
							// "User Input" column - only show when enabled for child branches and NOT in edit mode
							isChildBranch && colHideShow.userInput && view !== 'EDIT_VIEW' && (
								<td key={`metric-userInput-cell-${bIndex}`} className="branch-cell text-center">
									<div className="inner_tb">
										{branch.valueBeforeConversion != null 
											? `${Utils.formattedNumber(branch.valueBeforeConversion)}${branch.uomBeforeConversion ? ' ' + branch.uomBeforeConversion : ''}`
											: '-'}
									</div>
								</td>
							)
						].filter(Boolean);
					})
				}
			</tr>
		);
	};

	const editItem = (metric, branchId) => {
		const bData = { ...branchColEdited };
		bData[branchId] = true;
		setBranchColEdited(bData);
		setShowBranchDPSaveButton(true);
		showDataPoints(metric);
		setSelectedMetric(metric);
	}

	const renderDataPointRows = (metricId, topicId) => {
		if (!dataPoints[metricId]) return <></>;
		// Hide data point rows when topic is collapsed or when metric's data points are collapsed
		const isTopicHidden = topicId != null && topicVisibility[topicId] === 'hide';
		const isMetricDPHidden = dpVisibility[metricId] === 'hide';
		const shouldHide = isTopicHidden || isMetricDPHidden;

		return (
			dataPoints[metricId]?.map((dataPoint, dIndex) => {
				const isDataPointApplicable = dataPoint.dpApplicable !== false;
				return (
					<tr
						key={`dp-${dataPoint.id}-${dIndex}`}
						className={`dp-row ${shouldHide ? 'd-none' : ''} ${!isDataPointApplicable ? 'table-secondary text-muted' : ''}`}
					>
						<td className="name-cell">
							<span className="data_show_view01">
								{(i18n.language && dataPoint[i18n.language]) ? dataPoint[i18n.language] : dataPoint.name}
								{/* {dataPoint.name} */}
							</span>
						</td>
						{colHideShow.codes && <td className="text-center">
							{dataPoint.dataPointCode}
						</td>}
						{colHideShow.uom && <td className="text-center">
							{dataPoint.unit}
						</td>}
						<td className="total-cell">
							{
								!dataPoint.emissionLinked ?
									(dataPoint.combined !== null ? `${Utils.formattedNumber(dataPoint.combined)}` : '-')
									:
									(dataPoint.emissionCombinedInTCO2e != null ? `${Utils.formattedNumber(dataPoint.emissionCombinedInTCO2e)}` : '-')
							}
						</td>
						{colHideShow.showTotalReportedValue &&
							<td className="total-cell">
								{dataPoint.totalReportedValue != null ? `${Utils.formattedNumber(dataPoint.totalReportedValue)}` : '-'}
							</td>
						}
						{
							dataPoint.branches?.map((branch, bIndex) => {
								return renderDataPointBranchCell(dataPoint, branch, bIndex);
							})
						}
					</tr>
				)
			})
		);
	};

	const renderDPBranchCellEditableFields = (dataPoint, branch, index) => {
		const valueForField = branch?.valueBeforeConversion
			? Utils.formattedNumber(branch?.valueBeforeConversion)
			: Utils.formattedNumber(branch?.value);

		return (
			<Form validated={validation[`d-${dataPoint.id}`] === true && validation[`b-${branch.branchId}`] === true}>
				<div className='w-100 d-flex'>
					<div className=''>
						<input
							key={`branchValueField-${branch.branchId}-${index}-${valueForField}`}
							type="text"
							className="form-control branch-col "
							id={`branchValueField-${branch.branchId}-${index}`}
							defaultValue={valueForField}
							name="value"
							autoComplete="off"
							onChange={branchDPChanged(branch, dataPoint.id)}
							onKeyDown={handleKeyPress}
						/>
					</div>

					<select className='form-select '
						key={`branchUOMField-${branch.branchId}-${index}`}
						id={`branchUOMField-${branch.branchId}-${index}`}
						required={validCheck ? true : false}
						defaultValue={branch.uomBeforeConversion ? branch?.uomBeforeConversion : branch?.uom}
						onChange={onUOMChange(branch, dataPoint.id)}>
						{
							<>
								<option key='' value=''>{t("Select.label")}</option>
								{
									dataPoint?.relevantUoms?.length > 0
										?
										dataPoint?.relevantUoms?.sort((a, b) => a.localeCompare(b))?.map(u => {
											return <option key={u} value={u}>{uomList?.find(l => l.inputUnit === u)?.inputUnitName}</option>;
										})
										:
										uomList?.map(u => {
											return <option key={u.id} value={u.inputUnit}>{u.inputUnit}</option>;
										})
								}
							</>
						}
					</select>
				</div>
				{/* <div>
					<span>
						{branch.valueBeforeConversion ? `${Utils.formattedNumber(branch.valueBeforeConversion)} ${branch.uomBeforeConversion}` : '-'}
					</span>
					{
						!dataPoint.emissionLinked && branch.uomBeforeConversion !== dataPoint.unit &&
						<span className='text-muted mx-1'>{`/ ${Utils.formattedNumber(branch.value)} ${dataPoint.unit}`}</span>
					}
					{
						dataPoint.emissionLinked &&
						<span className='text-muted mx-1'>{`/ ${Utils.formattedNumber(branch.emissionValueInTCO2e)} tCO2-e`}</span>
					}
				</div> */}
				{
					isUserDataValidator(branch.branchId) &&
					<OverlayTrigger
						placement="auto"
						overlay={<Tooltip id="tooltip-like">  {t("CommentsandDocumentsFile.label")}</Tooltip>} >
						<span className="CommentsandDocumentsFile_btn" onClick={() => (view === 'EDIT_VIEW' ? showReportedValueCommentsAndUploads(dataPoint, branch, index) : showCommentsAndUploads(dataPoint, branch, index))}>
							<BsThreeDotsVertical />
						</span>
					</OverlayTrigger>
				}
			</Form>
		);
	}

	const renderDataPointBranchCell = (dataPoint, branch, index) => {
		const isDataPointApplicable = dataPoint.dpApplicable !== false;
		const isParentBranch = filter.parentEntities?.indexOf(branch.branchId) >= 0;
		const isChildBranch = !isParentBranch && (
			filter.childEntities?.indexOf(branch.branchId) >= 0 || 
			businessUnits.find(bu => bu.id === branch.branchId)?.level === 2
		);
		
		// "In UOM" column (main branch cell) - always show in edit mode, otherwise show when enabled
		// For child branches, show as separate column when both are enabled
		const shouldShowInUOM = !isChildBranch || (isChildBranch && (view === 'EDIT_VIEW' ? true : colHideShow.inUOM));
		const branchCellEditable = isDataPointApplicable && branchColEdited[branch.branchId] === true;
		
		return [
			shouldShowInUOM && (
				<td
					key={`dataPoint-branch-cell-${index}`}
					className={`branch-cell ${filter.parentEntities?.indexOf(branch.branchId) >= 0 ? 'parent-branch-cell' : 'child-branch-cell'}`}>
					<div className="inner_tb">
						{

							branchCellEditable
								? <>{renderDPBranchCellEditableFields(dataPoint, branch, index)}</>
								:
								<>
									{
										!dataPoint.emissionLinked ?

											branch.valueBeforeConversion && branch.uomBeforeConversion
												?
												<>
													{/* <span>{`${Utils.formattedNumber(branch.valueBeforeConversion)}`}</span>
													{
														branch.uomBeforeConversion !== dataPoint.unit &&
														<span className='text-muted mx-1'>{`(${Utils.formattedNumber(branch.value)})`}</span>
													} */}
													<span>{`${Utils.formattedNumber(branch.value)}`}</span>
												</>
												: `${branch.value !== null ? Utils.formattedNumber(branch.value) : '-'}`
											:
											<span className='text-muted mx-1'>{(branch.emissionValueInTCO2e != null ? `${Utils.formattedNumber(branch.emissionValueInTCO2e)} tCO2-e` : '-')}</span>
									}

									{/* {
										branch.value && branch.activity
											? <OverlayTrigger
												placement="top"
												overlay={renderDPBanchCellTooltip(branch)}>
												<span className="Info_dataView">
													<img src={refresh_icon} className="dp-info-icon" />
												</span>
											</OverlayTrigger>
											: ''
									} */}
									{
										isDataPointApplicable &&
										isUserDataValidator(branch.branchId) &&
										<OverlayTrigger
											placement="auto"
											overlay={<Tooltip id="tooltip-like">  {t("CommentsandDocumentsFile.label")}</Tooltip>} >
											<span className="CommentsandDocumentsFile_btn" onClick={() => { view === 'EDIT_VIEW' ? showReportedValueCommentsAndUploads(dataPoint, branch, index) : showCommentsAndUploads(dataPoint, branch, index) }}>
												<BsThreeDotsVertical />
											</span>
										</OverlayTrigger>
									}
								</>
						}
					</div>
				</td>
			),
			// "User Input" (Reported Value) column - only show when enabled for child branches and NOT in edit mode
			isChildBranch && colHideShow.userInput && view !== 'EDIT_VIEW' && (
				<td key={`dataPoint-userInput-cell-${index}`} className="branch-cell text-center">
					<div className="inner_tb">
						{branch.valueBeforeConversion != null 
							? `${Utils.formattedNumber(branch.valueBeforeConversion)}${branch.uomBeforeConversion ? ' ' + branch.uomBeforeConversion : ''}`
							: '-'}
						{isDataPointApplicable && isUserDataValidator(branch.branchId) && (
							<OverlayTrigger
								placement="auto"
								overlay={<Tooltip id="tooltip-reported-value">{t("CommentsandDocumentsFile.label")}</Tooltip>}>
								<span className="CommentsandDocumentsFile_btn" onClick={() => showReportedValueCommentsAndUploads(dataPoint, branch, index)}>
									<BsThreeDotsVertical />
								</span>
							</OverlayTrigger>
						)}
					</div>
				</td>
			)
		].filter(Boolean);

	};

	const renderDPBanchCellTooltip = (data) => {
		return (
			<Tooltip className="mytooltip">
				<div><b>Source</b> : {data.activity.source}</div>
				<div><b>Last Modified by</b> : {data.activity.lastModifiedBy}</div>
				<div><b>Date</b> : {moment(data.activity.lastModifiedDate).format("MMM Do YYYY, h:mm a")}</div>
			</Tooltip>
		);
	};

	const renderDataViewTable = () => {
		return (
			<div id='dataViewTableHolder 2' >
				<div className="DataView_Tab 3" >
					{filter.showQuantitative &&
						renderQuantitativeTabContent()
					}

				{filter.showQualitative &&
					//<QualitativeDataView filterData={filter} view={view} viewType={viewType} columnHideShow={colHideShow} />
					<QualitativeDataCardView 
						filterData={filter}
						view={view} 
						viewType={viewType} 
						columnHideShow={colHideShow}
						businessUnits={businessUnits}
					/>
				}
				</div>
			</div>
		);
	};

	const showCommentsAndUploads = (dataPoint, branch, index) => {
		setShowModal(true);
		if (view == 'EDIT_VIEW') {
			setIsCommentEdit(true);
		} else {
			setIsCommentEdit(false);
		}
		let data = {
			dataPointId: dataPoint.id,
			branchId: branch.branchId,
			id: branch.id,
			remark: branch.remark,
			attachments: branch.attachments ? branch.attachments : [],
			value: branch.valueBeforeConversion,
			uom: branch.uomBeforeConversion,
			unit: dataPoint.unit
		}
		setDPComments(branch.remark);
		setAttachedFiles(branch.attachments ? branch.attachments : []);
		setSelectedDp(data);
		setSelectedBranchData({ ...branch, dpName: dataPoint.name, emissionLinked: dataPoint.emissionLinked });
		if (view == 'EDIT_VIEW') {
			setupEdit(branch.remark, branch.attachments ? branch.attachments : []);
		}
	}

	const handleModalClose = () => {
		setShowModal(false);
		setShowReportedValueModal(false);
		setMessageConfirmation('');
		setSelectedDp({});
		setSelectedBranchData({});
		setDPComments('');
		setAttachedFiles([]);
		setSelectedFile({});
		setIsCommentEdit(false);
		setTempComments('');
		setTempAttachments([]);
	}

	const showReportedValueCommentsAndUploads = (dataPoint, branch, index) => {
		setShowReportedValueModal(true);
		setIsCommentEdit(view === 'EDIT_VIEW');
		const data = {
			dataPointId: dataPoint.id,
			branchId: branch.branchId,
			id: branch.id,
			remark: branch.remark,
			attachments: branch.attachments ? branch.attachments : [],
			value: branch.valueBeforeConversion,
			uom: branch.uomBeforeConversion,
			unit: dataPoint.unit
		};
		setDPComments(branch.remark);
		setAttachedFiles(branch.attachments ? branch.attachments : []);
		setSelectedDp(data);
		setSelectedBranchData({ ...branch, dpName: dataPoint.name, emissionLinked: dataPoint.emissionLinked });
		if (view === 'EDIT_VIEW') {
			setupEdit(branch.remark, branch.attachments ? branch.attachments : []);
		}
	};

	const handleReportedValueModalClose = () => handleModalClose();

	const uploadAttachments = (fileUploaded) => {
		if (fileUploaded) {
			const formData = new FormData();
			formData.append("document", fileUploaded);
			setLoaderDisplay(true);
			SubStdService.uploadAttachments(formData).then(res => {
				setLoaderDisplay(false);
				if (res.status === 200 || res.status === 201) {
					let files = tempAttachments;
					files.push(res.data)
					// setAttachedFiles(files);
					setTempAttachments(files);
					// toast.success("Document uploaded", {
					// 	position: toast.POSITION.TOP_RIGHT,
					// });
					fileInputRef.current.value = null;
				}
			}).catch((error) => {
				setLoaderDisplay(false);
			});
		} else {
			toast.warning('Please select a file');
		}
	}

	const handleFileSelect = (event) => {
		if (event.target.files[0].size <= 1024 * 1024 * 2) {
			const fileUploaded = event.target.files[0];
			uploadAttachments(fileUploaded);
		} else {
			fileInputRef.current.value = null;
			toast.warning('Upload files less than 2MB', {
				position: toast.POSITION.TOP_RIGHT,
				autoClose: 3000
			});
		}
	};

	const saveCommentsAndFiles = () => {
		if (!selectedDp?.dataPointId || selectedDp.branchId == null) return;
		let existData = { ...selectedDp };
		existData.remark = tempComments;
		existData.attachments = tempAttachments;
		setSelectedDp(existData);
		setLoaderDisplay(true);
		SubStdService.saveBranchCommentsAttachments(
			glbRegulationId,
			filter.reportingPeriod,
			existData
		).then(res => {
			setLoaderDisplay(false);
			if (res.status !== 200) return;
			toast.success(t("DataViewNew.commentsAttachmentsSaved.label"), {
				position: toast.POSITION.TOP_RIGHT,
			});
			// Add 3-second delay before refreshing data
			setTimeout(() => {
				getDataViewData(filter).catch(() => {});
			}, 3000);
			// onDataUpdate();
			handleModalClose();
		}).catch((error) => {
			setLoaderDisplay(false);
			handleModalClose();
		});
	}

	const getOCRData = (file) => {
		const parsedMetadata = file.metadata ? JSON.parse(file.metadata) : null;
		setParsedMetadata(parsedMetadata);
		setShowOCRModal(true);
	}

	const handleOCRModalClose = () => {
		setShowOCRModal(false);
		setParsedMetadata(null);
	}

	const renderExtractedContent = () => {
		if (!parsedMetadata?.extractedContent?.content) {
			return (
				<div className="text-center py-4">
					<p className="text-muted">{t("OCRData.noExtractedContent.label")}</p>
				</div>
			);
		}

		return (
			<div className="">
				<div className="d-flex align-items-center mb-3">
					<div className="me-2" style={{
						width: '4px',
						height: '20px',
						backgroundColor: '#28a745',
						borderRadius: '2px'
					}}></div>
					<h6 className="m-0" style={{
						color: '#2c3e50',
						fontWeight: '600',
						fontSize: '1rem'
					}}>
						{t("OCRData.extractedContent.label")}
					</h6>
				</div>
				<div className="border rounded p-3" style={{
					backgroundColor: '#f8f9fa',
					borderColor: '#dee2e6',
					maxHeight: '400px',
					overflowY: 'auto'
				}}>
					<div
						dangerouslySetInnerHTML={{
							__html: parsedMetadata.extractedContent.content
						}}
						style={{
							fontSize: '0.9rem',
							lineHeight: '1.5',
							color: '#495057'
						}}
					/>
				</div>
			</div>
		);
	};

	const renderSuggestedDataOptions = () => {
		if (!parsedMetadata.suggestedData) return <div className="mt-3">{t("OCRData.noSuggestedData.label")}</div>;

		if (parsedMetadata.suggestedData.type === 'multiple' && parsedMetadata.suggestedData.values) {
			return (
				<div className="">
					<div className="d-flex align-items-center mb-3">
						<div className="me-2" style={{
							width: '4px',
							height: '20px',
							backgroundColor: '#009efb',
							borderRadius: '2px'
						}}></div>
						<h6 className="m-0" style={{
							color: '#2c3e50',
							fontWeight: '600',
							fontSize: '1rem'
						}}>
							{t("OCRData.suggestedValues.label")}
						</h6>
					</div>
					{parsedMetadata.suggestedData.values.map((option, index) => {
						return (
							<div
								key={index}
								className={`ocr-option-card mb-3 p-3 border rounded cursor-pointer ${'border-light'}`}
								style={{
									transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
									position: 'relative',
									borderWidth: '1px',
									backgroundColor: 'white',
									borderColor: '#dee2e6'
								}}>
								<div className="d-flex align-items-center">
									<div
										className={`me-3 rounded-circle d-flex align-items-center justify-content-center ${'bg-light border'}`}
										style={{
											width: '24px',
											height: '24px',
											minWidth: '24px',
											borderColor: '#dee2e6',
											backgroundColor: '#f8f9fa'
										}}
									>

									</div>
									<div className="flex-grow-1">
										<div className="fw-bold" style={{ color: '#2c3e50' }}>
											{option.label}: {option.value} {option.unit}
										</div>
										{option.context && (
											<small className="text-muted" style={{ fontSize: '0.85rem' }}>
												{option.context}
											</small>
										)}
									</div>
								</div>
							</div>
						);
					})}
				</div>
			);
		} else if (parsedMetadata.suggestedData.value !== undefined) {
			return (
				<div className="mt-3">
					<div className="d-flex align-items-center mb-3">
						<div className="me-2" style={{
							width: '4px',
							height: '20px',
							backgroundColor: '#009efb',
							borderRadius: '2px'
						}}></div>
						<h6 className="m-0" style={{
							color: '#2c3e50',
							fontWeight: '600',
							fontSize: '1rem'
						}}>
							{t("OCRData.suggestedValue.label")}
						</h6>
					</div>
					<div
						className={`ocr-option-card p-3 border rounded cursor-pointer ${'border-light'}`}
						style={{
							transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
							position: 'relative',
							borderWidth: '1px',
							backgroundColor: 'white',
							borderColor: '#dee2e6'
						}}>
						<div className="d-flex align-items-center">
							<div
								className={`me-3 rounded-circle d-flex align-items-center justify-content-center ${'bg-light border'}`}
								style={{
									width: '24px',
									height: '24px',
									minWidth: '24px',
									borderColor: '#dee2e6',
									backgroundColor: '#f8f9fa'
								}}
							>

							</div>
							<div className="flex-grow-1">
								<div className="fw-bold" style={{ color: '#2c3e50' }}>
									{parsedMetadata.suggestedData.value} {parsedMetadata.suggestedData.unit || ''}
								</div>
							</div>
						</div>
					</div>
				</div>
			);
		}
		return null;
	};

	const renderOCRModal = () => {
		return (
			<Modal
				show={showOCRModal}
				onHide={handleOCRModalClose}
				size="lg"
				aria-labelledby="ocr-modal-title"
				centered
				backdrop="static"
				keyboard={false}
				data-testid="ocr-modal"
			>
				<Modal.Header closeButton>
					<Modal.Title as="h5" id="ocr-modal-title">
						{t("OCRData.title.label")}
					</Modal.Title>
				</Modal.Header>

				<Modal.Body>
					{parsedMetadata ? (
						<div className="row">
							<div className="col-md-6">
								{renderExtractedContent()}
							</div>
							<div className="col-md-6">
								{parsedMetadata.suggestedData ? (
									renderSuggestedDataOptions()
								) : (
									<div className="text-center py-4">
										<p className="text-muted">{t("OCRData.noSuggestedData.label")}</p>
									</div>
								)}
							</div>
						</div>
					) : (
						<div className="text-center py-4">
							<p className="text-muted">{t("OCRData.noData.label")}</p>
						</div>
					)}
				</Modal.Body>

				<Modal.Footer>
					<Button variant="secondary" onClick={handleOCRModalClose}>
						{t("Close.label")}
					</Button>
				</Modal.Footer>
			</Modal>
		);
	};

	const showReportedValueModalContent = (isEdit) => {
		return (
			<>
				{view === 'EDIT_VIEW' && (selectedBranchData?.valueBeforeConversion != null && selectedBranchData?.uomBeforeConversion) && (
					<>
						<div className="p-1">
							<div>
								<label className='mb-1'><b>Input: </b>
									{`${Utils.formattedNumber(selectedBranchData.valueBeforeConversion)} ${selectedBranchData.uomBeforeConversion}`}
									{selectedDp?.unit != null && selectedBranchData.uomBeforeConversion !== selectedDp.unit &&
										<span className='text-muted mx-1'>{`(${Utils.formattedNumber(selectedBranchData.value)} ${selectedDp.unit})`}</span>}
								</label>
							</div>
							{selectedBranchData.emissionLinked && (
								<>
									<div><label className='mb-1'><b>Emission Factor:</b> {`${Utils.formattedNumber(selectedBranchData.emissionFactor)}`}</label></div>
									<div><label className='mb-1'><b>Emission:</b> {`${Utils.formattedNumber(selectedBranchData.emissionValue)}`} kg CO2e</label></div>
								</>
							)}
						</div>
						<hr />
					</>
				)}
				{(selectedBranchData?.value != null && selectedBranchData?.activity) && (
					<div className="p-1">
						<label className='mb-1'><b>Log Information</b></label>
						<div>Source: {selectedBranchData?.activity?.source}</div>
						<div>Last Modified by: {selectedBranchData?.activity?.lastModifiedBy}</div>
						<div>Date: {moment(selectedBranchData?.activity?.lastModifiedDate).format("MMM Do YYYY, h:mm a")}</div>
					</div>
				)}
				{(selectedBranchData?.value != null && selectedBranchData?.activity) && <hr />}
				<div className="p-1">
					<label className='mb-1'><b>{t("Comments.label")}</b></label>
					{isEdit ? (
						<textarea className='form-control' rows="5" value={tempComments} placeholder="Provide your comments here"
							onChange={(e) => setTempComments(e.target.value)} />
					) : (
						<>
							{dpComments ? <p>{dpComments}</p> : <p><FcFinePrint className="me-2" /> No comments added</p>}
						</>
					)}
				</div>
				<hr />
				<div className="p-1">
					<label className='mb-1'><b>{t("Documents&File.label")}</b></label>
					{isEdit ? (
						<>
							<div className='d-flex'>
								<input className='form-control' type="file" id="imageUploadReportedValue"
									accept=".pdf, .docx, .png, .jpg, .xls, .xlsx" onChange={(e) => handleFileSelect(e)}
									onClick={(e) => { e.target.value = null; }} ref={fileInputRef} />
							</div>
							<div className='OCRattachedFiles_box p-1 4'>
								{tempAttachments.map((files, index) => (
									<div key={index} className="OcrattachedFiles_boxIn">
										<span className="attach_icon text-primary">
											{files.name.split('.').pop() === 'pdf' && <BsFilePdfFill className="pdf" />}
											{files.name.split('.').pop() === 'doc' && <BsFileWordFill />}
											{files.name.split('.').pop() === 'img' && <BsImageFill />}
										</span>
										<span className="file-name fw-medium">{files.name}</span>
										<div className="OcrattachedFiles_boxListICon">
											<ul>
												<OverlayTrigger placement="top" overlay={Utils.renderTooltip(t("Download.label"))}>
													<li onClick={() => downloadAttchement(files.externalId)}><BsDownload size={16} /></li>
												</OverlayTrigger>
												{isFilePreviewable(files.name) && (
													<OverlayTrigger placement="top" overlay={Utils.renderTooltip(t("Preview.label"))}>
														<li onClick={() => previewFile(files)}><BsEye size={16} /></li>
													</OverlayTrigger>
												)}
												<li onClick={() => showConfirm(files)} title="Delete"><BsX size={16} /></li>
											</ul>
										</div>
									</div>
								))}
							</div>
						</>
					) : (
						<div className='OCRattachedFiles_box p-1 3'>
							{attachedFiles?.length === 0 && noAttachmentLabel()}
							{attachedFiles.map((files, index) => (
								<div key={index} className="OcrattachedFiles_boxIn">
									<span className="attach_icon text-primary">
										{files.name.split('.').pop() === 'pdf' && <BsFilePdfFill className="pdf" />}
										{files.name.split('.').pop() === 'doc' && <BsFileWordFill />}
										{files.name.split('.').pop() === 'img' && <BsImageFill />}
									</span>
									<span className="file-name fw-medium">{files.name}</span>
									<div className="OcrattachedFiles_boxListICon">
										<ul>
											<OverlayTrigger placement="top" overlay={Utils.renderTooltip(t("Download.label"))}>
												<li onClick={() => downloadAttchement(files.externalId)}><BsDownload size={16} /></li>
											</OverlayTrigger>
											{isFilePreviewable(files.name) && (
												<OverlayTrigger placement="top" overlay={Utils.renderTooltip(t("Preview.label"))}>
													<li onClick={() => previewFile(files)}><BsEye size={16} /></li>
												</OverlayTrigger>
											)}
											{files.metadata && (
												<OverlayTrigger placement="top" overlay={Utils.renderTooltip('Show the extracted values')}>
													<li className='upload_OCR' onClick={() => getOCRData(files)}>
														<img src={ocr_icon} alt="OCR" className='upload_OCR_icon' />
													</li>
												</OverlayTrigger>
											)}
										</ul>
									</div>
								</div>
							))}
						</div>
					)}
				</div>
			</>
		);
	};

	const showStandardisedValueContent = () => {
		const hasInput = selectedBranchData?.valueBeforeConversion != null && selectedBranchData?.uomBeforeConversion;
		if (!hasInput) {
			return (
				<div className="p-1 text-muted">
					<FcFinePrint className="me-2" />{t("Nodatafound.label")}
				</div>
			);
		}
		return (
			<>
				<div className="p-1">
					<div>
						<label className='mb-1'><b>Input: </b>
							{`${Utils.formattedNumber(selectedBranchData.valueBeforeConversion)} ${selectedBranchData.uomBeforeConversion}`}
							{selectedDp?.unit != null && selectedBranchData.uomBeforeConversion !== selectedDp.unit &&
								<span className='text-muted mx-1'>{`(${Utils.formattedNumber(selectedBranchData.value)} ${selectedDp.unit})`}</span>}
						</label>
					</div>
					{selectedBranchData?.emissionLinked && (
						<>
							<div><label className='mb-1'><b>Emission Factor:</b> {`${Utils.formattedNumber(selectedBranchData.emissionFactor)}`}</label></div>
							<div><label className='mb-1'><b>Emission:</b> {`${Utils.formattedNumber(selectedBranchData.emissionValue)}`} kg CO2e</label></div>
						</>
					)}
				</div>
			</>
		);
	};

	const showAttachedFiles = () => {
		return (
			<>
				{
					(selectedBranchData.valueBeforeConversion != null && selectedBranchData.uomBeforeConversion) &&
					<>
						<div className="p-1">
							<div>
								<label className='mb-1'><b>Input: </b>
									{`${Utils.formattedNumber(selectedBranchData.valueBeforeConversion)} ${selectedBranchData.uomBeforeConversion}`}
									{
										selectedBranchData.uomBeforeConversion !== selectedDp.unit &&
										<span className='text-muted mx-1'>{`(${Utils.formattedNumber(selectedBranchData.value)} ${selectedDp.unit})`}</span>
									}
								</label>
							</div>
							{
								selectedBranchData.emissionLinked &&
								<>
									<div>
										<label className='mb-1'><b>Emission Factor:</b> {`${Utils.formattedNumber(selectedBranchData.emissionFactor)}`}</label>
									</div>
									<div>
										<label className='mb-1'><b>Emission:</b> {`${Utils.formattedNumber(selectedBranchData.emissionValue)}`} kg CO2e</label>
									</div>
								</>
							}
						</div>
						<hr />
					</>
				}
				{
					(selectedBranchData.value != null && selectedBranchData.activity) &&
					<>
						<div className="p-1">
							<label className='mb-1'><b>Log Information</b></label>
							<div>Source: {selectedBranchData?.activity?.source}</div>
							<div>Last Modified by: {selectedBranchData?.activity?.lastModifiedBy}</div>
							<div>Date: {moment(selectedBranchData?.activity?.lastModifiedDate).format("MMM Do YYYY, h:mm a")}</div>
						</div>
						<hr />
					</>
				}
				<div className="p-1">
					<label className='mb-1'><b>	{t("Comments.label")}</b></label>
					{
						dpComments &&
						<p>{dpComments}</p>
					}
					{
						!dpComments &&
						<p><FcFinePrint className="me-2" /> No comments added</p>
					}
				</div>
				<hr />
				<div className="p-1">
					<label className='mb-1'><b>{t("Documents&File.label")}</b></label>
					<div className='OCRattachedFiles_box p-1 3'>
						{attachedFiles?.length === 0 && noAttachmentLabel()}
						{
							attachedFiles.map((files, index) => {
								return (
									<div key={index}
										className="OcrattachedFiles_boxIn"
									>
										<span className="attach_icon text-primary" >
											{files.name.split('.').pop() === 'pdf' && <BsFilePdfFill className="pdf" />}
											{files.name.split('.').pop() === 'doc' && <BsFileWordFill />}
											{files.name.split('.').pop() === 'img' && <BsImageFill />}
										</span>
										<span className="file-name fw-medium">{files.name}</span>
										<div className="OcrattachedFiles_boxListICon">
											<ul>
												<OverlayTrigger
													placement="top"
													overlay={Utils.renderTooltip(t("Download.label"))}>
													<li
														onClick={() => downloadAttchement(files.externalId)} >
														<BsDownload size={16} />
													</li>
												</OverlayTrigger>
												{isFilePreviewable(files.name) && (
													<OverlayTrigger
														placement="top"
														overlay={Utils.renderTooltip(t("Preview.label"))}>
														<li onClick={() => previewFile(files)} >
															<BsEye size={16} />
														</li>
													</OverlayTrigger>
												)}
												{
													files.metadata &&
													<OverlayTrigger
														placement="top"
														overlay={Utils.renderTooltip('Show the extracted values')}>
														<li className='upload_OCR' onClick={() => getOCRData(files)}>
															<img src={ocr_icon} alt="OCR" className='upload_OCR_icon' />
														</li>
													</OverlayTrigger>
												}
											</ul>
										</div>
									</div>
								);
							})
						}
					</div>
				</div>
			</>
		);
	}

	const showConfirm = (data) => {
		setMessageConfirmation(t("DeleteFileConfirmationMessage.label"));
		setSelectedFile(data)
		setShowConfirmation(true);
	}

	const confirmDelete = (val) => {
		setShowConfirmation(false);
		if (val) {
			deleteFile(selectedFile.id);
		}
	};

	const deleteFile = (id) => {
		const index = tempAttachments.findIndex(x => x.id === id);
		if (index >= 0) {
			tempAttachments.splice(index, 1);
			let files = JSON.stringify(tempAttachments)
			setTempAttachments(JSON.parse(files));
		}
	}

	const downloadAttchement = (id) => {
		setLoaderDisplay(true);
		SubStdService.getDocumentsAttached(id)
			.then((response) => {
				setLoaderDisplay(false);
				let fetchDataModified = `data:${response.data.mimeType};base64,${response.data.file}`;
				let link = document.createElement("a");
				link.href = fetchDataModified;
				link.download = response.data.name;
				link.click();
			})
			.catch((error) => {
				setLoaderDisplay(false);
				console.log(error);
			});
	}

	// Helper function to check if file is previewable (PDF or image)
	const isFilePreviewable = (fileName) => {
		if (!fileName) return false;
		const extension = fileName.split('.').pop().toLowerCase();
		const previewableExtensions = ['pdf', 'jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp', 'svg'];
		return previewableExtensions.includes(extension);
	};

	// Helper function to check if file is an image
	const isImageFile = (fileName) => {
		if (!fileName) return false;
		const extension = fileName.split('.').pop().toLowerCase();
		const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp', 'svg'];
		return imageExtensions.includes(extension);
	};

	// Helper function to check if file is a PDF
	const isPdfFile = (fileName) => {
		if (!fileName) return false;
		const extension = fileName.split('.').pop().toLowerCase();
		return extension === 'pdf';
	};

	const previewFile = (file) => {
		// Check if file is previewable
		if (!isFilePreviewable(file.name)) {
			toast.warning(t("PreviewOnlyForPDFAndImages.label"), {
				position: toast.POSITION.TOP_RIGHT,
			});
			return;
		}

		setLoaderDisplay(true);
		SubStdService.getDocumentsAttached(file.externalId)
			.then((response) => {
				setLoaderDisplay(false);
				if (response.status === 200) {
					const data = response.data;

					// Helper function to parse metadata (can be stringified JSON or normal JSON)
					const parseMetadata = (metadata) => {
						if (!metadata) return null;
						if (typeof metadata === 'string') {
							try {
								return JSON.parse(metadata);
							} catch (error) {
								console.error('Error parsing metadata JSON:', error);
								return null;
							}
						}
						return metadata;
					};

					setPreviewData({
						file: data.file,
						name: data.name,
						mimeType: data.mimeType || 'application/pdf',
						metadata: parseMetadata(data.metadata),
						externalId: file.externalId
					});
					setShowPreviewModal(true);
					setActiveTab('pdf');
				}
			})
			.catch((error) => {
				setLoaderDisplay(false);
				toast.error("Unable to preview file", {
					position: toast.POSITION.TOP_RIGHT,
				});
			});
	}

	const setupEdit = (comments, attachments) => {
		// setIsCommentEdit(true);
		let files = JSON.stringify(attachments)
		setTempAttachments(JSON.parse(files));
		setTempComments(comments);
	}

	const cancelEdit = () => {
		setIsCommentEdit(false);
		setTempAttachments([]);
		setTempComments('');
		fileInputRef.current.value = null;
	};

	const renderQuantitativeTabContent = () => {
		return (
			<div>
				<div className="table-holder table-responsive mt-0 2">
					<Table bordered >
						{renderTableHeader()}
						<tbody>
							{renderCategoryRow()}
							{dataViewData?.length === 0 && renderEmptyDataLabel()}
							{
								dataViewData?.length > 0 &&
								dataViewData?.map((topic, tIndex) => {
									return (
										hasQuantitativeMetrics(topic.metricData)
											?
											<React.Fragment key={`topic-${topic.topicId}-${tIndex}`}>
												{renderTopicRow(topic, tIndex)}
												{
													topic.metricData?.length > 0 &&
													topic.metricData?.map((metric, mIndex) => {
														return (
															<React.Fragment key={`metric-${metric.id}-${mIndex}`}>
																{renderMetricRow(metric, mIndex, topic.topicId)}
																{renderDataPointRows(metric.id, topic.topicId)}
															</React.Fragment>
														);
													})
												}
											</React.Fragment>
											: null
									);
								})
							}
						</tbody>
					</Table>
				</div>
				{/* {
					showBranchDPSaveButton &&
					<div className="p-2 text-center DataView_tableSave">
						<button type="button"
							onClick={() => { setEditedBranch('edited') }}
							className="btn btn-secondary ms-2 px-4 sbmBtn">
							{t("Cancel.label")}
						</button>
						<button type="button"
							onClick={() => {
								saveMetricDataPoint();
								saveBranchDataPoint();
							}}
							className="btn btn-primary ms-2 px-4 sbmBtn">
							{t("Save.label")}
						</button>
					</div>
				} */}
			</div>
		);
	};

	const renderCommentsAndDocumentsModal = () => {
		return (
			<Modal show={showModal}
				onHide={handleModalClose}
				size="lg"
				aria-labelledby="contained-modal-title-vcenter"
				centered backdrop="static"
				keyboard={false}>
				<Modal.Header closeButton>
					<Modal.Title as="h5">
						{selectedBranchData?.emissionLinked ? selectedBranchData.dpName : (isUserDataValidator(selectedBranchData?.branchId) ? t("CommentsandDocumentsFile.label") : "")}
					</Modal.Title>
				</Modal.Header>

				<Modal.Body>
					{showStandardisedValueContent()}
				</Modal.Body>
				<Modal.Footer>
					<Button variant="secondary" onClick={() => handleModalClose()}>
						{t("Close.label")}
					</Button>
				</Modal.Footer>
			</Modal>
		)
	};

	const renderReportedValueModal = () => {
		return (
			<Modal show={showReportedValueModal} onHide={handleReportedValueModalClose} size="lg" aria-labelledby="contained-modal-title-vcenter-reported" centered backdrop="static" keyboard={false}>
				<Modal.Header closeButton>
					<Modal.Title as="h5" id="contained-modal-title-vcenter-reported">
						{selectedBranchData?.emissionLinked ? selectedBranchData.dpName : (isUserDataValidator(selectedBranchData?.branchId) ? t("CommentsandDocumentsFile.label") : "")}
					</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					{showReportedValueModalContent(isCommentEdit)}
				</Modal.Body>
				<Modal.Footer>
					{isCommentEdit ? (
						<>
							<Button variant="secondary" onClick={handleReportedValueModalClose}>{t("Cancel.label")}</Button>
							<Button variant="primary" className="sbmBtn" onClick={() => saveCommentsAndFiles()}>{t("Update.label")}</Button>
						</>
					) : (
						<Button variant="secondary" onClick={handleReportedValueModalClose}>{t("Close.label")}</Button>
					)}
				</Modal.Footer>
			</Modal>
		);
	};

	const renderPreviewModal = () => {
		// Helper function to parse metadata (can be stringified JSON or normal JSON)
		const parseMetadata = (metadata) => {
			if (!metadata) return null;
			if (typeof metadata === 'string') {
				try {
					return JSON.parse(metadata);
				} catch (error) {
					console.error('Error parsing metadata JSON:', error);
					return null;
				}
			}
			return metadata;
		};

		const parsedMetadata = parseMetadata(previewData.metadata);
		const hasOCRData = parsedMetadata && Object.keys(parsedMetadata).length > 0;
		const fileUrl = previewData.file ? `data:${previewData.mimeType};base64,${previewData.file}` : '';
		const isImage = isImageFile(previewData.name);
		const isPdf = isPdfFile(previewData.name);

		return (
			<Modal
				show={showPreviewModal}
				onHide={() => setShowPreviewModal(false)}
				size="xl"
				aria-labelledby="preview-modal-title"
				centered
				backdrop="static"
				keyboard={false}
				style={{ maxWidth: '95vw' }}
			>
				<Modal.Header closeButton>
					<Modal.Title as="h5" id="preview-modal-title">
						File Preview: {previewData.name}
					</Modal.Title>
				</Modal.Header>

				<Modal.Body style={{ height: '70vh', padding: '0' }}>

					{hasOCRData && (
						<div className="mb-3">
							<Tabs
								activeKey={activeTab}
								onSelect={(k) => setActiveTab(k)}
								className="border-bottom"
							>
								<Tab eventKey="pdf" title={isImage ? "Image Viewer" : "PDF Viewer"} className="h-100">
									<div style={{ height: 'calc(70vh - 120px)', overflow: 'hidden' }}>
										{fileUrl && (
											isImage ? (
												<div style={{
													height: '100%',
													display: 'flex',
													alignItems: 'center',
													justifyContent: 'center',
													backgroundColor: '#f8f9fa'
												}}>
													<img
														src={fileUrl}
														alt={previewData.name}
														style={{
															maxWidth: '100%',
															maxHeight: '100%',
															objectFit: 'contain'
														}}
													/>
												</div>
											) : (
												<iframe
													src={fileUrl}
													width="100%"
													height="100%"
													style={{ border: 'none' }}
													title="PDF Preview"
												/>
											)
										)}
									</div>
								</Tab>
								{hasOCRData && <Tab eventKey="ocr" title="OCR Data" className="h-100">
									<div style={{ height: 'calc(70vh - 120px)', overflow: 'hidden' }}>
										<div className="row h-100" style={{ margin: 0 }}>
											{/* Extracted Content */}
											<div className="col-md-8" style={{ height: '100%', padding: '15px' }}>
												<div className="h-100 d-flex flex-column">
													<h6 className="text-primary mb-3">Extracted Content</h6>
													<div className="flex-grow-1 border rounded p-3" style={{
														backgroundColor: '#f8f9fa',
														overflow: 'auto',
														minHeight: 0
													}}>
														<div
															dangerouslySetInnerHTML={{
																__html: parsedMetadata?.extractedContent?.content || 'No content available'
															}}
															style={{
																fontFamily: 'monospace',
																fontSize: '14px',
																lineHeight: '1.6',
																color: '#495057'
															}}
														/>
													</div>
												</div>
											</div>

											{/* Suggested Value */}
											<div className="col-md-4" style={{ height: '100%', padding: '15px' }}>
												<div className="h-100 d-flex flex-column">
													<h6 className="text-primary mb-3">Suggested Values</h6>
													<div className="flex-grow-1 border rounded p-3" style={{
														backgroundColor: '#fff',
														minHeight: 0,
														overflow: 'auto'
													}}>
														{parsedMetadata?.suggestedData ? (
															// Check if it's multiple values format
															parsedMetadata.suggestedData.type === 'multiple' && parsedMetadata.suggestedData.values ? (
																<div>
																	{parsedMetadata.suggestedData.values.map((item, index) => (
																		<div key={index} className="border-bottom pb-3 mb-3" style={{
																			borderColor: '#e9ecef'
																		}}>
																			<div className="d-flex justify-content-between align-items-start mb-2">
																				<span className="badge bg-primary fs-6">{item.label}</span>
																				<span className="text-muted small">#{index + 1}</span>
																			</div>
																			<div className="text-center mb-2">
																				<div className="display-6 fw-bold text-primary">
																					{item.value}
																				</div>
																				<div className="text-muted fs-6">
																					{item.unit}
																				</div>
																			</div>
																			{item.context && (
																				<div className="text-muted small text-center">
																					{item.context}
																				</div>
																			)}
																		</div>
																	))}
																</div>
															) : (
																// Single value format (original structure)
																<div className="text-center h-100 d-flex align-items-center justify-content-center">
																	<div>
																		<div className="display-4 fw-bold text-primary mb-2">
																			{parsedMetadata.suggestedData.value}
																		</div>
																		<div className="text-muted fs-5">
																			{parsedMetadata.suggestedData.unit}
																		</div>
																	</div>
																</div>
															)
														) : (
															<div className="text-center text-muted h-100 d-flex align-items-center justify-content-center">
																No suggested data available
															</div>
														)}
													</div>
												</div>
											</div>
										</div>
									</div>
								</Tab>}
							</Tabs>
						</div>
					)}

					{!hasOCRData && (
						<div style={{ height: 'calc(70vh - 80px)', overflow: 'hidden' }}>
							{fileUrl && (
								isImage ? (
									<div style={{
										height: '100%',
										display: 'flex',
										alignItems: 'center',
										justifyContent: 'center',
										backgroundColor: '#f8f9fa'
									}}>
										<img
											src={fileUrl}
											alt={previewData.name}
											style={{
												maxWidth: '100%',
												maxHeight: '100%',
												objectFit: 'contain'
											}}
										/>
									</div>
								) : (
									<iframe
										src={fileUrl}
										width="100%"
										height="100%"
										style={{ border: 'none' }}
										title="PDF Preview"
									/>
								)
							)}
						</div>
					)}
				</Modal.Body>

				<Modal.Footer>
					<Button variant="secondary" onClick={() => setShowPreviewModal(false)}>
						{t("Close.label")}
					</Button>
					<Button
						variant="primary"
						onClick={() => downloadAttchement(previewData.externalId)}
						className="d-flex align-items-center"
					>
						<BsDownload className="me-2" />
						Download
					</Button>
				</Modal.Footer>
			</Modal>
		);
	};

	const renderGHGEmissionTooltip = (metric) => {
		return (
			<Tooltip className="mytooltip">
				<label>{t("ViewUpdateGHGDataCollectionToolTip.label")}</label>
			</Tooltip>
		);
	}

	const gotoEditGHGData = () => {
		navigate({
			pathname: "/company_admin/editGHGData",
		});
	}

	const setupEditCells = (id) => {
		const ids = [...selectedEditDp];
		const index = selectedEditDp.indexOf(id);
		if (index >= 0) {
			ids.splice(index, 1);
		} else {
			ids.push(id);
		}
		setSelectedEditDp(ids);
	}

	// Sort handler
	const handleSort = () => {
		const sortedData = [...dataViewData];
		if (sortOrder === "asc") {
			if (sortedData.length > 0) {
				sortedData.forEach(element => {
					if (element.metricData.length > 0) {
						element.metricData.sort((a, b) => b.value - a.value);
					}
				});
			}
			setSortOrder("desc");
		} else {
			if (sortedData.length > 0) {
				sortedData.forEach(element => {
					if (element.metricData.length > 0) {
						element.metricData.sort((a, b) => a.value - b.value);
					}
				});
			}
			setSortOrder("asc");
		}
		setDataViewData(sortedData);
	};


	// Function to check equation execution status
	const checkEquationExecutionStatus = async () => {
		EquationService.getEquationExecutionStatus(companyId).then(res => {
			const wasInProgress = equationExecutionInProgress;
			const isInProgress = res.data === true;

			setEquationExecutionInProgress(isInProgress);

			// If equation execution just finished (was true, now false):
			// - if nothing is being edited, silently reload the data
			// - otherwise, don't disturb the in-progress edit; just flag the data as stale
			//   so the user can reload/reapply the filter themselves once they're done
			if (wasInProgress && !isInProgress) {
				const isEditingInProgress = view !== 'CONSOLIDATED_VIEW'
					|| showBranchDPSaveButton
					|| editedBranch !== null
					|| Object.values(branchColEdited).some(Boolean);

				if (isEditingInProgress) {
					setDataStale(true);
				} else {
					getDataViewData(filter).catch(() => {});
				}
			}
		}).catch(err => {
		});
	};

	const reloadStaleData = () => {
		setDataStale(false);
		getDataViewData(filter).catch(() => {});
	};

	return (
		<div id='dataViewHolder' data-testid="data-view-container">
			<div className="List_header mb-1">
				<div className="d-flex align-items-center">
					{view == 'EDIT_VIEW' && <h5 className="MH">{t("Periodic.label")} ( {t("EditMode.label")} )</h5>}
					{view == 'CONSOLIDATED_VIEW' && <h5 className="MH">{t("Periodic.label")}</h5>}
				</div>
				<DataViewHeaderNew
					filter={filter}
					regulationId={glbRegulationId}
					view={view}
					viewType={viewType}
					equationExecutionInProgress={equationExecutionInProgress}
					dataStale={dataStale}
					onReloadStaleData={reloadStaleData}
					onFilterClick={() => setShowFilter(!showFilter)}
					onViewChange={(v) => {
						if (!showBranchDPSaveButton) {
							setView(v);
							const f = {
								...filter,
								periodFrom: dvFilter?.periodFrom ?? `${year}-01-01`,
								periodTo: dvFilter?.periodTo ?? dvFilter?.periodType == 'MONTHLY' ? null : `${year}-12-31`,
							};
							if (v != 'EDIT_VIEW') {
								applyFilter(f);
							}
						} else {
							setEditedBranch('edited');
						}
					}}
					onViewTypeChange={(v) => setViewType(v)}
					onColHideShow={(val) => {
						// Ensure at least one of inUOM or userInput is enabled
						if (!val.inUOM && !val.userInput) {
							// Cannot disable both, keep current state
							return;
						}
						const values = {
							...colHideShow,
							codes: val.codes,
							uom: val.uom,
							userInput: val.userInput,
							inUOM: val.inUOM,
							showTotalReportedValue: val.showTotalReportedValue
						}
						setColHideShow(values)
					}}
					filterChange={(year, month) => {
						const paddedMonth = month.toString().padStart(2, '0');
						const ftr = {
							...filter,
							reportingPeriod: `${year}-${paddedMonth}-01`,
							periodFrom: `${year}-${paddedMonth}-01`,
							periodTo: null,
							periodType: "MONTHLY"
						};
						const isSamePeriod = filter.periodType === ftr.periodType
							&& filter.periodFrom === ftr.periodFrom
							&& filter.periodTo === ftr.periodTo
							&& filter.reportingPeriod === ftr.reportingPeriod;
						if (isSamePeriod) return;
						applyFilter(ftr);
					}}
					onExitEdit={(val) => {
						setEditedBranch('edited');
					}}
					onSaveEdit={(val) => {
						// saveMetricDataPoint();
						saveBranchDataPoint();
					}}
				/>
			</div>

			<div className={showFilter ? '' : 'd-none'}>
				<DataViewFilterNew view={view}
					dataViewType={viewType}
					yearFilter={yearFilter}
					onApplyFilter={(f) => applyFilter(f)}
					onResetFilter={() => resetData()}
					viewFilter={showFilter}
					onFilterHide={(value) => setShowFilter(value)}
					changeFilter={filter}
					parentEntData={(entities) => {
						// Update business units with parent entities
						setBusinessUnits(prev => {
							const filtered = prev.filter(bu => bu.level !== 1);
							return [...filtered, ...entities.map(entity => ({ ...entity, level: 1 }))];
						});
					}}
					childEntData={(entities) => {
						// Update business units with child entities
						setBusinessUnits(prev => {
							const filtered = prev.filter(bu => bu.level !== 2);
							return [...filtered, ...entities.map(entity => ({ ...entity, level: 2 }))];
						});
					}} />
			</div>

			{renderDataViewTable()}

			{
				editedBranch !== null &&
				<ConfirmationModal
					modalShow={editedBranch !== null}
					id={editedBranch}
					title={t("confirmation.label")}
					messageText={"Do you want to save the changes before exiting edit mode?"}
					callbackModal={saveChangesConfirmationCallBack}
					confirmBtn={t("Save")}
					CancelBtn={t("Don't Save")}
				/>
			}
			{
				showConfirmation &&
				<ConfirmationModal
					modalShow={true}
					messageText={messageConfirmation}
					callbackModal={confirmDelete}
					confirmBtn={t("Confirm.label")}
					CancelBtn={t("Cancel.label")}
				/>
			}
			{renderCommentsAndDocumentsModal()}
			{renderReportedValueModal()}
			{renderPreviewModal()}
			{renderOCRModal()}
		</div>
	);
};

export default withTranslation()(DataViewNew);
